<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-text>
            <v-container>
              <v-row justify="center" class="black--text">
                <v-col cols="12" md="5">
                  <div class="mb-5">
                    <h2 class="text-md-h5">
                      Gabung ke kelas
                    </h2>
                  </div>
                  <div class="mb-3">
                    <div class="foot-list-icon float-left">
                      <v-icon :color="maincolor">
                        mdi-checkbox-marked-outline
                      </v-icon>
                    </div>
                    <div class="foot-list-content">
                      Gunakan kode kelas yang terdiri dari 5-7 huruf atau angka, tanpa spasi atau simbol
                    </div>
                  </div>
                  <div class="mb-3">
                    <p>
                      Jika Anda mengalami masalah saat bergabung ke kelas, buka artikel
                      <router-link :to="{ name: 'Login' }">
                        Pusat Bantuan
                      </router-link>
                    </p>
                  </div>
                </v-col>
                <v-col cols="12" md="1" v-show="!$vuetify.breakpoint.smAndDown">
                  <v-divider vertical></v-divider>
                </v-col>
                <v-col cols="12" md="5">
                  <div class="mb-5">
                    <h2 class="text-md-h5">
                      Kode kelas
                    </h2>
                  </div>
                  <div class="mb-3">
                    <p>
                      Mintalah kode kelas kepada pengajar, lalu masukkan kode di sini.
                    </p>
                  </div>
                  <v-form
                    @submit.prevent="submitRegjobseeker"
                    ref="formregjobseeker"
                    v-model="formadd.jobseeker"
                    lazy-validation>
                    <v-row justify="center" no-gutters>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <alertsp :alertdata="alertregjs"></alertsp>
                            <v-text-field
                              outlined
                              v-model="regjobseeker.firstname"
                              :rules="[rules.required]"
                              label="Kode kelas *"
                              name="classcode"
                              required>
                            </v-text-field>
                            <v-btn
                              large
                              block
                              :loading="loading.regjs"
                              :disabled="loading.regjs || !formadd.jobseeker"
                              :color="maincolor"
                              class="mr-4 mt-3 white--text text-capitalize"
                              type="submit">
                              Gabung
                            </v-btn>
                          </v-col>
                          <v-col cols="12" class="text-center">
                            Ingin buat kelas?
                            <router-link :to="{ name: 'Createclass' }">
                              Buat kelas
                            </router-link>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'Joinclass',
  data: () => ({
    alertregjs: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      regjs: false,
      regcom: false,
      getdata: false,
    },
    publickey: '123',
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_kerja' },
      { text: 'Deskripsi', value: 'deskripsi_kerja' },
      { text: 'Status', value: 'status_kerja' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    regjobseeker: {
      firstname: '',
      lastname: '',
      email: '',
      password: '',
    },
    regcompany: {
      firstname: '',
      lastname: '',
      email: '',
      companyname: '',
      companyphone: '',
      password: '',
    },
    addjeniskerja: {
      nama_kerja: '',
      deskripsi_kerja: '',
      email: '',
      company: '',
    },
    formadd: {
      jobseeker: false,
      company: false,
      passwordjs: false,
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (!!v && v.length >= 8) || 'Min 8 characters',
      nik: (v) => (!!v && v.length >= 16) || 'Min 16 characters',
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
    tabdata: null,
    dmodal: {
      jeniskerja: false,
    },
    dmodaldata: {
      jeniskerja: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    // this.getJeniskerja();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJeniskerja() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jeniskerja/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitRegcompany() {
      this.alertdata.show = false;
      if (this.$refs.formregcompany.validate()) {
        if (this.publickey) {
          // console.log(this.regcompany);
          this.loading.regcom = true;
          this.axios
            .post(
              this.api + '/api/auth/regcompany',
              qs.stringify(
                this.regcompany,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.publickey,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                // console.log(res);
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formregcompany.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Congratulations <br/> your account already created <br/>';
                  this.alertdata.text += 'Please verify your email <br/> "' + resdata.data + '"<br/> Thank you';
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.regcom = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.regcom = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    submitRegjobseeker() {
      this.alertregjs.show = false;
      if (this.$refs.formregjobseeker.validate()) {
        if (this.publickey) {
          // console.log(this.regjobseeker);
          this.loading.regjs = true;
          this.axios
            .post(
              this.api + '/api/auth/regjobseeker',
              qs.stringify(
                this.regjobseeker,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.publickey,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formregjobseeker.reset();
                  this.alertregjs.show = true;
                  this.alertregjs.type = 'success';
                  this.alertregjs.text = 'Congratulations <br/> your account already created <br/>';
                  this.alertregjs.text += 'Please verify your email <br/> "' + resdata.data + '"<br/> Thank you';
                } else {
                  this.alertregjs.show = true;
                  this.alertregjs.type = 'error';
                  this.alertregjs.text = resdata.message;
                }
              } else {
                this.alertregjs.show = true;
                this.alertregjs.type = 'error';
                this.alertregjs.text = 'Internal services error!';
              }
              this.loading.regjs = false;
            })
            .catch((error) => {
              this.alertregjs.show = true;
              this.alertregjs.type = 'error';
              this.alertregjs.text = 'Internal services error!';
              this.loading.regjs = false;
            });
        } else {
          this.alertregjs.show = true;
          this.alertregjs.type = 'error';
          this.alertregjs.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jeniskerja') {
        this.dmodal.jeniskerja = false;
      } else {
        this.dmodal.jeniskerja = false;
      }
    },
    editJeniskerja(item) {
      this.dmodal.jeniskerja = true;
      this.dmodaldata.jeniskerja = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejeniskerja.validate()) {
        if (this.tokenscr) {
          this.axios
            .put(
              this.api + '/api/jeniskerja/',
              qs.stringify(
                this.dmodaldata.jeniskerja,
              ),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  // tslint:disable-next-line:max-line-length
                  this.alertupdate.text = this.dmodaldata.jeniskerja.nama_kerja + '" berhasil diubah!';
                  this.getJeniskerja();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
